export default {
	title: "",
	subtitle: "SPEI (Dynamic Clabe)",
  path: "transaction_SPEI_dynamic_clabe",
	paragraphs: [
		"Dynamic CLABE is a way for you to be able to accurately track each transaction made, you will share a specific CLABE number with the payer, so the payment will be connected to the same transaction you created. For use this feature, you’ll need to request us to activate it in your account.",
		"For each MXN cash-in transaction created, a 'payment_info' object will be included. Inside this object, you will find the 'dynamic_clabe' that is unique to that transaction. This way you can share this dynamic CLABE with your customer, since it is exclusively created for that specific transaction. You will need to create a transaction following the payload below.",
		"This allows the correct transaction to be paid and reconciled, this feature is very useful for businesses where the payment is made by a third party. "
	], 
	request:  {
		method: "POST", 
		endpoint: "/transactions",
		payload: {
			"transaction": {
				"currency": "MXN",
				"exchange_currency": "MXN",
				"value": "1000.00",
				"from_bank_account_id": "your real MXN account id",
				"to_bank_account_id": "your internal MXN cash-in id",
				"subject_id": "Person or company id"
			}
		},
		responses: {
			"data": {
				"value": "1000.00",
				"to_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "Company's name",
					"owner_document_number": "tax id test",
					"owner_company": {
						"social_name": "Company's name",
						"id": "e336bdbf-4fee-4ecc-9f4b-56bdc092222e",
						"document_type": "tax_id",
						"document_number": "tax id test"
					},
					"nickname": null,
					"internal": true,
					"intermediary_bank_account": null,
					"id": "6bfeabfb-e4ba-4967-b7d8-01c1cb13897a",
					"iban": null,
					"currency": "MXN",
					"branch_number": null,
					"branch_country": "MEX",
					"bank": {
						"swift": null,
						"name": "Internal",
						"ispb": null,
						"id": "6facab8d-573e-44d0-a4bd-ce2600368263",
						"country": "MEX",
						"code": "032"
					},
					"account_type": "conta-corrente",
					"account_number": null,
					"aba": null
				},
				"subject_is_receiver": false,
				"subject_id": "d082a457-608b-467a-a30d-89495b61a57f",
				"subject": {
					"updated_at": "2024-09-06T00:21:16.956245",
					"status": "approved",
					"social_name": "Mexican Person Test",
					"rfc_pf": "PERP940807436",
					"required_clearance_level": 1,
					"references": [],
					"phone_number": "997353481",
					"net_monthly_average_income": "0.00",
					"inserted_at": "2024-02-20T18:28:56.297935",
					"id": "d082a457-608b-467a-a30d-89495b61a57f",
					"fiscal_country": "Mexico",
					"email": "teste@teste.teste.com.mex",
					"document_type": "curp",
					"document_number": "PERP940807HJCDSD00",
					"clearance_level": 2,
					"birth_date": null,
					"address_street": "teste",
					"address_state": "teste",
					"address_postal_code": "4521215",
					"address_number": "40",
					"address_neighborhood": "teste",
					"address_country": "Mexico",
					"address_complement": "teste",
					"address_city": "teste"
				},
				"status": "pending",
				"source_name": "Mexican Person Test",
				"source_document_type": "curp",
				"source_document_number": "PERP940807HJCDSD00",
				"payment_info": {
					"dynamic_clabe": "646010366700010938"
				},
				"meta": {},
				"inserted_at": "2024-09-06T00:21:16.947728",
				"id": "11aea01c-e6f7-4b74-92a9-23f315048704",
				"from_credit_card": null,
				"from_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "FACILITA PAY",
					"owner_document_number": "N/A",
					"nickname": null,
					"intermediary_bank_account_id": null,
					"id": "cf7dae7b-410a-4cb8-a8ec-f9a145925526",
					"iban": null,
					"currency": "MXN",
					"branch_number": null,
					"branch_country": null,
					"bank": {
						"swift": null,
						"name": "Sistema de Transferencias y Pagos STP, S.A. de C.V., SOFOM E.N.R.",
						"ispb": null,
						"id": "f4affad3-51a0-4d87-9c6e-97b0443e278b",
						"country": "MEX",
						"code": "646"
					},
					"account_type": "conta-corrente",
					"account_number": "646180366700010004",
					"aba": null
				},
				"for_exchange": false,
				"exchanged_value": "1000.00",
				"exchange_under_request": false,
				"exchange_currency": "MXN",
				"estimated_value_until_exchange": false,
				"currency": "MXN",
				"cleared": true
			}
		}
	},
	parameterPayload: [
		{
			name: "transaction",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
        },
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "For SPEI Dynamic Clabe, use MXN currency",
		},{
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "Currency to be exchanged (ISO 4217 format). One of: MXN, USD, EUR"
		},{
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Amount to be sent to internal bank account balance or your international bank account with two decimal places. E.g: \"1000.00\""
		},{
			name: "transaction.from_bank_account_id",
			type: "string",
			required: true,
			description: "This field represents the ID of your FACILITA MXN bank account that we will open for you"
		},{
			name: "transaction.to_bank_account_id",
			type: "string",
			required: true,
			description: "Destination bank account UUID. Its currency must match the currency informed on the \"exchange_currency\" attribute"
		},{
			name: "transaction.subject_id", 
			type: "string", 
			required: true, 
			description: "UUID of the Mexican registered person/company"
		},
	],
	footerNotes: '',
	troubleshooting: {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionSpeiDynamicClabe.js